export default function initVideo() {
    // ---------------------------------------
    // JW Player setup
    // ---------------------------------------
    if (window.jwplayer) {
        window.jwplayer.key = "a7FKx3kj2wUMh+SHQlcg3hkzAtCZf0erMYsHaue4B6w=";

        document.querySelectorAll(".video-player").forEach(el => {
            const id = el.id;
            const file = el.dataset.videoUrl;

            if (!id || !file) return;

            window.jwplayer(id).setup({
                base: '/dist/js/vendor/jwplayer',
                file: file,
                image: el.dataset.videoThumb || "",
                mediaid: el.dataset.videoId || "",
                title: el.dataset.videoTitle || "",
                width: "100%",
                aspectratio: "16:9",
                skin: {
                    active: "#fff",
                    background: "#254257",
                    inactive: "#ffffff"
                }
            });
        });
    }

    // ---------------------------------------
    // Video overlay controls
    // ---------------------------------------
    const overlay = document.getElementById('videoOverlay');
    if (!overlay) return; // No overlay on this page

    const video = overlay.querySelector('video');

    window.openVideo = function () {
        overlay.setAttribute('aria-hidden', 'false');
        overlay.classList.add('active');

        if (video) {
            video.play();
        }
    };

    window.closeVideo = function () {
        overlay.setAttribute('aria-hidden', 'true');
        overlay.classList.remove('active');

        if (video) {
            video.pause();
            video.currentTime = 0;
        }
    };
}